import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import Landing from "@/pages/Landing";
import Leaderboard from "@/pages/Leaderboard";
import Statistics from "@/pages/Statistics";
import Tournaments from "@/pages/Tournaments";
import TournamentDetail from "@/pages/TournamentDetail";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminTournament from "@/pages/AdminTournament";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen flex items-center justify-center text-[#525252]">Loading…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#FDFBF7]">
      <Header />
      <main className="flex-1">{children}</main>
      <footer className="border-t border-[#E5E5E5] bg-white py-8">
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col sm:flex-row items-center justify-between gap-2 text-sm text-[#525252]">
          <span className="font-heading font-bold text-[#0A0A0A]">ANNI'S PLACE DARTS</span>
          <span>Maaspoort 23, 6001 BN Weert</span>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <div className="App font-body">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout><Landing /></Layout>} />
            <Route path="/leaderboard" element={<Layout><Leaderboard /></Layout>} />
            <Route path="/statistics" element={<Layout><Statistics /></Layout>} />
            <Route path="/tournaments" element={<Layout><Tournaments /></Layout>} />
            <Route path="/tournaments/:id" element={<Layout><TournamentDetail /></Layout>} />
            <Route path="/login" element={<Layout><Login /></Layout>} />
            <Route
              path="/admin"
              element={<ProtectedRoute><Layout><AdminDashboard /></Layout></ProtectedRoute>}
            />
            <Route
              path="/admin/tournament/:id"
              element={<ProtectedRoute><Layout><AdminTournament /></Layout></ProtectedRoute>}
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
